import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { LandingComponent } from './component/landing/landing.component';
import { AccessdeniedComponent } from './component/children/accessdenied/accessdenied.component';
import { permissionGuard } from './guards/permission.guard';

export const routes: Routes = [
    {
        path:'sst',
        loadComponent: () => import('./component/sst/sst.component').then(m => m.SstComponent),
        canActivate: [permissionGuard],
        data:{role:'sst'}
    },{
        path:'bulkupload',
        loadComponent: () => import('./component/bulkupload/bulkupload.component').then(m => m.BulkuploadComponent),
        canActivate: [permissionGuard],
        data:{role:'bulkUpload'}
    },{
        path:'xpwd',
        loadComponent: () => import('./component/xpwd/xpwd.component').then(m => m.XpwdComponent),
        canActivate: [permissionGuard],
        data:{role:'xpwd'}
    },{
        path:'xpwd/viewOrDelete/:id',
        loadComponent: () => import('./component/xpwd/view-or-delete/view-or-delete.component').then(m => m.ViewOrDeleteComponent),
        canActivate: [permissionGuard],
        data:{role:'xpwd'}
    },{
        path:'xpwd/edit/:id',
        loadComponent: () => import('./component/xpwd/create/create.component').then(m => m.CreateComponent),
        canActivate: [permissionGuard],
        data:{role:'xpwd'}
    },{
        path:'xpwd/create',
        loadComponent: () => import('./component/xpwd/create/create.component').then(m => m.CreateComponent),
        canActivate: [permissionGuard],
        data:{role:'xpwd'}
    },{
        path:'reports',
        loadComponent: () => import('./component/reports/reports.component').then(m => m.ReportsComponent),
        canActivate: [permissionGuard],
        data:{role:'mdr'}
    },{
        path:'monthlyclosing',
        loadComponent: () => import('./component/admin/monthlyclosing/monthlyclosing.component').then(m => m.MonthlyclosingComponent),
        canActivate: [permissionGuard],
        data:{role:'admin'}
    },{
        path:'closingdate',
        loadComponent: () => import('./component/admin/closingdateandrule/closingdateandrule.component').then(m => m.ClosingdateandruleComponent),
        canActivate: [permissionGuard],
        data:{role:'open'}
    },{
        path:'closinghistory',
        loadComponent: () => import('./component/admin/closinghistory/closinghistory.component').then(m => m.ClosinghistoryComponent),
        canActivate: [permissionGuard],
        data:{role:'admin'}
    },{
        path:'accessdenied',
        component: AccessdeniedComponent
    },{
        path:'',
        component: LandingComponent
    },{
        path:'**', redirectTo: ''
    }
];

@NgModule({ 
    imports: [RouterModule.forRoot(routes, {
    })],
    exports: [RouterModule]
  })

  export class AppRoutingModule { }